import React, { useEffect } from 'react'

interface ModalProps {
  visible: boolean
  onDismiss: () => void
  header?: React.ReactNode
  footer?: React.ReactNode
  children: React.ReactNode
  size?: 'small' | 'medium' | 'large' | 'max'
  dismissible?: boolean
  closeAriaLabel?: string
}

export const Modal: React.FC<ModalProps> = ({ visible, onDismiss, header, footer, children, size = 'medium' }) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [visible])

  if (!visible) return null

  const widths = {
    small: '400px',
    medium: '600px',
    large: '800px',
    max: '90vw',
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onDismiss}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: widths[size],
          width: '100%',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          margin: '20px',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {header && (
          <div
            style={{
              padding: '16px 20px',
              borderBottom: '1px solid #e0e0e0',
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >
            {header}
          </div>
        )}
        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>{children}</div>
        {footer && (
          <div
            style={{
              padding: '16px 20px',
              borderTop: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}
